<template>
    <div class="footer">
        <div class="item" @click="onMenu(1)">
            <div class="img1" :class="{'img1-1': menus == 1}" style='width: 28px;height: 28px;margin: 5px auto 0 auto;'></div>
            <span :class="{'colFF7A45': menus == 1}">首页</span>
        </div>
        <div class="item" @click="onMenu(2)">
            <div class="img2" :class="{'img2-1': menus == 2}" style='width: 28px;height: 28px;margin: 5px auto 0 auto;'></div>
            <span :class="{'colFF7A45': menus == 2}">分类</span>
        </div>
        <div class="item" @click="onMenu(3)">
            <div class="img3" :class="{'img3-1': menus == 3}" style='width: 28px;height: 28px;margin: 5px auto 0 auto;'><div class="num" v-show="cartNum" v-text="cartNum"></div></div>
            <span :class="{'colFF7A45': menus == 3}">购物车</span>
        </div>
        <div class="item" @click="onMenu(5)">
            <div class="img5" :class="{'img5-1': menus == 5}" style='width: 28px;height: 28px;margin: 5px auto 0 auto;'></div>
            <span :class="{'colFF7A45': menus == 5}">我的</span>
        </div>
    </div>
</template>
<script>
import { versions } from './version'
import { mapState, mapActions } from 'vuex'
export default {
    name: 'foot',
    data () {
        return {
            userInfo: null,
            memberCode: '',
            merchantCode: ''
        }
    },
    computed: {
        ...mapState({
            cartNum: state => state.b2b.cartNum
        })
    },
    props: {
        menus: Number,
        member: String,
        merchant: String
    },
    methods: {
        ...mapActions([
            'getCartNums'
        ]),
        onMenu (num) {
            let params = {
                type: 5,
                dfx_type: num + 1
            }
            localStorage.removeItem('tab')
            if (num === 1) {
                params.event = 41
                this.$router.replace({ path: '/b2b/home/index' })
            } else if (num === 2) {
                params.event = 52
                this.$router.replace({ path: '/b2b/goods/allGoods' })
            } else if (num === 3) {
                if (this.userInfo.authenticationStatus !== 3) {
                    this.$router.push({ path: '/b2b/company/index' })
                    return
                }
                params.event = 3
                this.$router.replace({ path: '/b2b/cart/cart' })
            } else {
                params.event = 59
                this.$router.replace({ path: '/b2b/order/index' })
            }
            // if (this.menus !== num) this.APPBuriedPoint(JSON.stringify(params))
        },
        APPBuriedPoint (params) {
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'callBuriedPoint',
                    'params': params
                })
            } else {
                window.kfxt.callBuriedPoint(params)
            }
        },
        onCartNum () {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
            if (this.userInfo.belongMerchantCode) {
                this.getCartNums({ memberCode: this.userInfo.companyCode, merchantCode: this.userInfo.belongMerchantCode })
            }
        }
    },
    mounted () {
        this.onCartNum()
    }
}
</script>
<style lang="scss" scoped>
.footer{
    border-top: 1px solid #D1D1D6;
    background-color: #ffffff;
    height: 100px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    text-align: center;
    color: #333333;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    z-index: 99;
    font-size: 20px;
}
.item{
    text-align: center;
    .num{
        position: absolute;
        top: -4px;
        right: -10px;
        color: #ffffff;
        background: #FF6725;
        border-radius: 40%;
        padding: 0 8px;
    }
    .img1{
        background: url(../../assets/img/b2b/tab1.png) no-repeat;
        background-size: 100%;
        &.img1-1{
            background: url(../../assets/img/b2b/tab1-1.png) no-repeat;
            background-size: 100%;
        }
    }
    .img2{
        background: url(../../assets/img/b2b/tab2.png) no-repeat;
        background-size: 100%;
        &.img2-1{
            background: url(../../assets/img/b2b/tab2-1.png) no-repeat;
            background-size: 100%;
        }
    }
    .img3{
        position: relative;
        background: url(../../assets/img/b2b/tab3.png) no-repeat;
        background-size: 100%;
        &.img3-1{
            background: url(../../assets/img/b2b/tab3-1.png) no-repeat;
            background-size: 100%;
        }
    }
    .img4{
        background: url(../../assets/img/b2b/tab4.png) no-repeat;
        background-size: 100%;
        &.img4-1{
            background: url(../../assets/img/b2b/tab4-1.png) no-repeat;
            background-size: 100%;
        }
    }
    .img5{
        background: url(../../assets/img/b2b/tab5.png) no-repeat;
        background-size: 100%;
        &.img5-1{
            background: url(../../assets/img/b2b/tab5-1.png) no-repeat;
            background-size: 100%;
        }
    }
    span{
        color: #666666;
    }
}
</style>
